<div class="pagamentos-resumo ion-padding">
  <div class="pagamentos-resumo__flex">
    <ion-icon class="pagamentos-resumo__icon" name="cash-sharp" color="medium"></ion-icon>

    <div class="pagamentos-resumo__content">
      <ng-container *ngIf="pagamentosEmitidos; else templatePagamentosNaoEmitidos">

        <div class="pagamentos-resumo__flex pagamentos-resumo__valores">
          <ion-text>
            <p class="font-text ion-no-margin">{{ valorContrato | currency: 'BRL' }}</p>
          </ion-text>
          <ion-chip>
            <ion-label>{{ statusPagamentos }}</ion-label>
          </ion-chip>
        </div>

        <ion-text>
          <p class="description-text">
            Entrada de {{ valorEntrada | currency: 'BRL' }} + <br>
            {{ quantidadeParcelas }} parcelas de {{ valorParcela | currency: 'BRL' }}
          </p>
        </ion-text>
      </ng-container>

      <ng-template #templatePagamentosNaoEmitidos>
        <ion-text>
          <p class="font-text font-text--medium">
            Os pagamentos deste bairro ainda não foram emitidos. Você será notificado quando os boletos forem gerados.
          </p>
        </ion-text>
      </ng-template>
    </div>
  </div>

  <ion-button *ngIf="pagamentosEmitidos" mode="md" (click)="navegarParaPagamentos()">
    <ion-icon slot="start" name="barcode"></ion-icon>
    Visualizar boletos
  </ion-button>
</div>